import * as React from 'react'
import Svg, { Path } from 'react-native-svg'

function SvgComponent(props: any) {
  return (
    <Svg
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <Path
        d="M1.71 7.5l6.25-6.25 6.25 6.25"
        stroke="#7D66FF"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export default SvgComponent
